import { useEffect, useState } from "react";
import "./PopupForm.css";

export default function PopupForm() {
  const [show, setShow] = useState(false);

  // AUTO OPEN ON LOAD
  useEffect(() => {
    const timer = setTimeout(() => {
      setShow(true);
    }, 1000); // 1 sec delay

    return () => clearTimeout(timer);
  }, []);

  if (!show) return null;

  return (
    <div className="popup-overlay">
      <div className="popup-box">

        {/* CLOSE BUTTON */}
        <button className="close-btn" onClick={() => setShow(false)}>
          ✕
        </button>

        <h2>Get in Touch with Trusted Gold Buyers.</h2>

        <form>
          <input type="text" placeholder="Name" />
          <input type="email" placeholder="Email" />
          <input type="tel" placeholder="Phone" />

          <select>
            <option>Gold Purity</option>
             <option>18K</option>
            <option>20K</option>
            <option>22K</option>
            <option>24K</option>
          </select>

          <input type="number" placeholder="Gram" />

          <button type="submit" className="submit-btn">
            SUBMIT
          </button>
        </form>

      </div>
    </div>
  );
}